import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { ClientBirthDayReportBo, getEmployeeReportBo} from './employee-report.modal';
import { ColumnChangeBO, columnWidth } from '../icd10/icd10.model';
import * as pbi from 'powerbi-client';
import { IMyDpOptions } from 'mydatepicker';
// import { ConfigurationService } from 'src/app/configuration.service';
import { CommonApiService } from 'src/app/commonapiservice';
import { EnvironmentService } from 'src/app/environment.service';
@Component({
  selector: 'app-employee-report',
  templateUrl: './employee-report.component.html',
  styleUrls: ['./employee-report.component.scss']
})
export class EmployeeReportComponent implements OnInit {
  BirthDayReport: ClientBirthDayReportBo = new ClientBirthDayReportBo();
  @ViewChild('gridEmployeeReport') public gridEmployeeReport: GridComponent;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  private onDestroy$: Subject<void> = new Subject<void>();
  public data: Observable<DataStateChangeEventArgs>;
  public formatOptions: object;
  isClientReportInactive:boolean=false;
  id: string = '00000000-0000-0000-0000-000000000000';
  datalength: number = 0;
  ClientStatusList: any = [];
  QpEmployeeDropDown: any = [];
  genderList: any = [];
  TypeofWaiver: any = [];
  TypeofClient: any = [];
  PcaTypeList: any = [];
  AssessmentingRatingList: any = [];
  filterOptions: FilterSettingsModel;
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  ReportList: getEmployeeReportBo= new getEmployeeReportBo()
  locationId: any = '00000000-0000-0000-0000-000000000000';
  @ViewChild("reportContainer", { static: false }) reportContainer: ElementRef;
  initialPage: object;
  clienttypeLid: any;
  genderLid: any;
  ViewReport: boolean = false;
  height: string = "200px";
  employeeId: any;
  pCATypeLid: any;
  typeofWaiverLid: any;
  assessmentRatingLid: any;
  ReportstatusLid: any;
  isEnabledExcel: boolean = false;
  isEnabledPrint: boolean = false;
  ColumnArray: columnWidth[];
  EmployeeReportList: any = [];
  arraycol: any = [];
  ValidationDate: any;
  EmployeeReportDropData: string[] = [];
  clientReportFilterList: [{ label: string, value: string }];
  date: Date;
  reptitle: any = '';
  StatusLst: any;
  CaseStatus: any;
  environmentServicedata:any;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: true,
    editableDateField: true
  };
  constructor(public CommonAPI: CommonApiService, 
    // public configurationservice: ConfigurationService, 
    public environmentService: EnvironmentService,
    private cdr: ChangeDetectorRef, 
    private router: Router, 
    public dateservice: DateService, 
    public global: GlobalComponent, 
    public toastrService: ToastrService,
    public datepipe: DatePipe,) {
    this.data = CommonAPI;
    this.environmentServicedata = this.environmentService.getEnvironmentsConfiguration();

  }
  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }
  ngOnInit(): void {
    if (
      this.global.globalAgencyId == null ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == '00000000-0000-0000-0000-000000000000'
    ) {
      return;
    }
    if (this.global.globalLocationId == null || this.global.globalLocationId == undefined || this.global.globalLocationId == '') {
      this.locationId = '00000000-0000-0000-0000-000000000000';
    }
    else {
      this.locationId = this.global.globalLocationId;
    }
    if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
      this.getQpEmployeeDropDown();
      this.getGender();
      this.getstatus();
      this.getClientTypeLid();
      this.getTypeofwaiver();      
    }
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.filterOptions = { type: 'Menu' };
    let pag = null
    if (this.global.globalColumn != null && this.global.globalColumn != undefined && this.global.globalColumn != "") {
      pag = JSON.parse(this.global.globalColumn.column)[0].Clientreport.Pagesize;
      this.ReportList.pageitem = pag;
    }
    else {
      pag = 10;
    }
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: pag, pageSize: pag, pageSizes: this.pageSizes };
  }
  show() {
    this.gridEmployeeReport.columnChooserModule.openColumnChooser(200, 50);
  }
  refreshToGetDropDownValues(ListCode: string) {
    if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
      let url = "api/LOV/getLovDropDown?"
      let params = new URLSearchParams();
      params.append("ListCode", ListCode);
      this.CommonAPI.RefreshDropDownList(ListCode,params, url, "LovDropDown").then((data: any) => {
        
        if (ListCode == 'STATUS') {
          this.ClientStatusList = data;
          this.ClientStatusList.forEach(element => {
            element.id = element.id;
          });
        }
        
        if (ListCode == 'GENDER') {
          this.genderList = data?.filter(ele=>ele.lovCode?.toUpperCase()!='OTHERS');
          this.genderList.forEach(element => {
            element.id = element.id;
          })
        }
        if (ListCode == 'CLIENTTYPE') {
          this.TypeofClient = data;
          this.TypeofClient.forEach(element => {
            element.Key = element.Key.toString();
          })
        }
        // if (ListCode == 'PCATYPE') {
        //   this.PcaTypeList = data;
        //   this.PcaTypeList.forEach(element => {
        //     element.Key = element.Key.toString();
        //   })
        // }
        if (ListCode == 'TYPEOFWAIVER') {
          this.TypeofWaiver = data;
          this.TypeofWaiver.forEach(element => {
            element.Key = element.Key.toString();
          });
        }
      })
    }
  }
  getClientTypeLid() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "CLIENTTYPE");
    this.CommonAPI.getDropDownList('CLIENTTYPE',params, url, "LovDropDown").then((data: any) => {
      this.TypeofClient = data;
      this.TypeofClient.forEach(element => {
        element.id = element.id.toString();
      })
    },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    )
  }
  // getAssessmentingRating() {
  //   let url = "api/LOV/getLovDropDown?"
  //   let params = new URLSearchParams();
  //   params.append("Code", "ASSESSMENTRATING");
  //   this.CommonAPI.getDropDownList('ASSESSMENTRATING',params, url, "LovDropDown").then((data: any) => {
  //     this.AssessmentingRatingList = data;
  //     this.AssessmentingRatingList.forEach(element => {
  //       element.Key = element.Key.toString();
  //     })
  //   },
  //     (err: any) => {
  //       this.toastrService.error(err);
  //       setTimeout(() => {
  //         this.toastrService.clear();
  //       }, 8000);
  //     }
  //   )
  // }
  getstatus() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
    this.CommonAPI.getDropDownList('STATUS',params, url, "LovDropDown").then((data: any) => {
      this.ClientStatusList = data;
      this.ClientStatusList.forEach(element => {
        element.id = element.id;
      });
      this.EmployeeReportDropData = data.map(e => e.Value);
      this.ClientStatusList.push({ lovVaule: 'All', lovName: "All" });
      this.ReportstatusLid = this.ClientStatusList.filter(st => st.lovName == "Active")[0].id;
      this.ReportList.statusLid = this.ReportstatusLid.toString();
      this.ReportList.statusLid = (this.ReportstatusLid)
      this.getEmployeereportFilter();
    },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    )
  }
 
  getGender() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "GENDER");
    this.CommonAPI.getDropDownList('GENDER',params, url, "LovDropDown").then((data: any) => {
      this.genderList = data?.filter(ele=>ele.lovCode?.toUpperCase()!='OTHERS');
      this.genderList.forEach(element => {
        element.id = element.id;
      })
    },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    )
  }
  
  getQpEmployeeDropDown() {
    let params = new URLSearchParams();
    // params.append("employeeId", emptype.toString());
    // params.append("LocationId", this.locationId);
    let url = "api/Employee/employeeDropDown?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.QpEmployeeDropDown = data;
      this.QpEmployeeDropDown.forEach(element => {
        element.Key = element.Key;
      })
    },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    )
  }
  getTypeofwaiver() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "TYPEOFWAIVER");
    this.CommonAPI.getDropDownList('TYPEOFWAIVER',params, url, "LovDropDown").then((data: any) => {
      this.TypeofWaiver = data;
      this.TypeofWaiver.forEach(element => {
        element.id = element.id;
      })
    },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    )
  }
 
  ApplyFilter() {
    this.ReportList.employeeId = (this.employeeId ?? "") == "" ? null : (this.employeeId);
    this.ReportList.statusLid = (this.ReportstatusLid ?? "") == "" ? null : (this.ReportstatusLid);
    this.getEmployeereportFilter();
  }
  RefreshFilter() {
    this.ReportList = new getEmployeeReportBo();
    this.employeeId = null;
    this.ReportList.currentpageno = 1;
    this.gridEmployeeReport.pageSettings.currentPage = 1;
    this.ReportList.pageitem = this.gridEmployeeReport.pageSettings.pageSize;
    this.ReportstatusLid = this.ClientStatusList.filter(st => st.lovName == "Active")[0].id;
    this.ReportList.statusLid = (this.ReportstatusLid ?? "") == "" ? "00000000-0000-0000-0000-000000000000" : (this.ReportstatusLid);
    this.getEmployeereportFilter();
    this.gridEmployeeReport.clearFiltering();
    this.gridEmployeeReport.clearSorting();
  }
  ClearFilter() {
    this.ReportstatusLid = this.ClientStatusList.filter(st => st.lovName == "Active")[0].id;
    this.ReportList.statusLid = (this.ReportstatusLid ?? "") == "" ? "00000000-0000-0000-0000-000000000000" : (this.ReportstatusLid);
    this.ReportList.employeeId = "00000000-0000-0000-0000-000000000000";
   
    this.employeeId = null;
    this.assessmentRatingLid = null;
    this.typeofWaiverLid = null;
    this.getEmployeereportFilter();
  }
  getEmployeereportFilter() {
    // this.ReportList.locationID = this.locationId;
    let responseData =
    {
      result: "result",
      count: "count",
    }
    let url = "api/Employee/getEmployeeReport"
    this.CommonAPI.outputValues(url, this.ReportList, responseData, "");
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.EmployeeReportList = data.result;
      count = count + 1;
      this.datalength = data.Count;
      if (data != null && data != undefined && count == 1) {
       
      }
      if ((data != null && data.result.length > 0)) {
        this.isEnabledExcel = true;
        this.isEnabledPrint = true;

      }
      else {
        this.isEnabledExcel = false;
        this.isEnabledPrint = false;

      }
      if (data != null && data.result.length > 15) {
        this.gridEmployeeReport.height = '500';
      }
      else {
        this.gridEmployeeReport.height = 'auto';
      }

    })
  }
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridEmployeeReport.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].Clientreport.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].Clientreport.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].Clientreport.ShowColumns.length != count1 || this.arraycol[0].Clientreport.HideColumns.length != count) {
            this.arraycol[0].Clientreport.ShowColumns = showarr;
            this.arraycol[0].Clientreport.HideColumns = hidearr;
            this.arraycol[0].Clientreport.Pagesize = this.gridEmployeeReport.pagerModule.pagerObj.pageSize
           
          }
        }
      }
    }
    this.ReportList.currentpageno = this.gridEmployeeReport.pagerModule.pagerObj.currentPage;
    this.ReportList.pageitem = this.gridEmployeeReport.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.ReportList.type = args.columnType
    }
  }
  public dataStateChange(state): void {
    let type = (state.action.requestType).toString();
    if (type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ReportList.orderColumn = state.sorted[0].name;
        this.ReportList.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
      if (this.ReportList.type == "number") {
        this.ReportList.value = state.action.currentFilterObject.value.toString();
        this.ReportList.field = state.action.currentFilterObject.field;
      }
      if (this.ReportList.type == "date") {
        this.ReportList.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
        this.ReportList.field = state.action.currentFilterObject.field;
      }
      else if (this.ReportList.type == "number") {
        this.ReportList.value = state.action.currentFilterObject.value.toString();
        this.ReportList.field = state.action.currentFilterObject.field;
      }
      else {
        this.ReportList.value = state.action.currentFilterObject.value;
        this.ReportList.field = state.action.currentFilterObject.field;
      }

      this.ReportList.matchCase = state.action.currentFilterObject.matchCase;
      this.ReportList.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (type == "filtering" && state.action.action == "clearFilter") {
        this.ReportList.field = "Name";
        this.ReportList.matchCase = false;
        this.ReportList.operator = "contains";
        this.ReportList.value = "";
        this.ReportList.type = "string"
      }
    }
    this.getEmployeereportFilter();
    if (type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Clientreport.Pagesize != state.take) {
          this.arraycol[0].Clientreport.Pagesize = state.take
          
        }
      }
    }
  }
 
  onResize(args) {
    if (this.ColumnArray != undefined && this.ColumnArray != null) {
      const column = this.gridEmployeeReport.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      
    }
  }
  MovetoClientParent() {
    this.router.navigateByUrl('/Employee');
  }
  exportEmployeeReportCsv() {
    let url = "api/Employee/exportEmployeeReportCsv";
    this.CommonAPI.saveorUpdateFunctionFileSaver(this.ReportList, url, "EmployeeReport.csv");
  }
  getClientBirthdayReport() {
    // let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    // let embedUrl = "";
    // this.reptitle = "Client BirthDay Report";
    // var startDate = this.BirthDayReport.fromDate != null && this.BirthDayReport.fromDate != undefined && this.BirthDayReport.fromDate != "" ?
    //   this.global.getDateTimeString(this.BirthDayReport.fromDate)
    //   : null;
    // var endDate = this.BirthDayReport.endDate != null && this.BirthDayReport.endDate != undefined && this.BirthDayReport.endDate != "" ?
    //   this.global.getDateTimeString(this.BirthDayReport.endDate) : null;
    // embedUrl = "https://app.powerbi.com/rdlEmbed?reportId=" + this.configurationservice.configuration.ClientBirthDayReportId +
    //   "&rp:agencyid=" + this.global.globalAgencyId + "&rp:startdate=" + startDate + "&rp:enddate="
    //   + endDate + "&rp:locationid=" + this.locationId + "&rp:ExecTime=" + currentTime +
    //   "&rdl:parameterPanel=hidden";

    // this.ViewReport = true;
    // this.CommonAPI.CommonFunctionforPowerBiToken().then((token) => {
    //   document.getElementById('OpenCBirthDayModal').click();
    //   let embedReportId = this.configurationservice.configuration.ClientBirthDayReportId;
    //   let config = {
    //     type: 'report',
    //     tokenType: pbi.models.TokenType.Aad,
    //     accessToken: token[0],
    //     embedUrl: embedUrl,
    //     id: embedReportId,
    //     settings: {},
    //     viewmode: pbi.models.ViewMode.View
    //   };
    //   let reportContainer = this.reportContainer.nativeElement;
    //   let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    //   let report = powerbi.embed(reportContainer, config);
    //   report.off("loaded");
    //   report.on("loaded", () => {
    //   });
    // });

  }
  BirthDayReportDateChanges(event, type, name) {
    if (type == "inputchange") {
      if (name == 'BirthDayfromDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.BirthDayReport.fromDate = val1;
        }
      }
      if (name == 'BirthDayEndDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.BirthDayReport.endDate = val1;
        }
      }
    }
    if (type == "datechanged") {
      if (name == 'BirthDayfromDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.BirthDayReport.fromDate = val1;

          var StartDate = new Date(this.BirthDayReport.fromDate);
          let setDate = StartDate.setDate(StartDate.getDate() + 365);
          let getDate = setDate;
          this.ValidationDate = this.datepipe.transform(getDate, "MM/dd/yyyy");
          this.clearEndTimeValidation();
        }
      }
      if (name == 'BirthDayEndDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.BirthDayReport.endDate = val1;
          this.clearEndTimeValidation();
        }
      }
    }
  }
  clearEndTimeValidation() {
    if (this.BirthDayReport.fromDate != null && this.BirthDayReport.fromDate != undefined && this.BirthDayReport.fromDate != '' &&
      this.BirthDayReport.endDate != null && this.BirthDayReport.endDate != undefined && this.BirthDayReport.endDate != '') {

      let EndDate = this.datepipe.transform(this.BirthDayReport.endDate, "MM/dd/yyyy");

      if (new Date(EndDate).getTime() > new Date(this.ValidationDate).getTime()) {
        this.toastrService.error("Date range should not be greater than 1 year");
        this.BirthDayReport.endDate = null;

        setTimeout(() => {
          this.toastrService.clear();
        }, 3000);

      }
      if (this.BirthDayReport.endDate != null && this.BirthDayReport.endDate != undefined && this.BirthDayReport.endDate != '') {

        if (new Date(this.BirthDayReport.fromDate).getTime() > new Date(this.BirthDayReport.endDate).getTime()) {
          this.BirthDayReport.endDate = null;
          this.toastrService.error("end time should greater than start time");
          setTimeout(() => {
            this.toastrService.clear();
          }, 3000);
          return;
        }
      }
    }
  }
  clearModal() {
    this.BirthDayReport = new ClientBirthDayReportBo();
  }
  closeGenerateModal() {
    this.ViewReport = false;

    document.getElementById('OpenCBirthDayModal').click();
  }
  generateRpReport() {
    let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.ViewReport = true;
    this.reptitle = "RP Report";
    this.CommonAPI.CommonFunctionforPowerBiToken().then((token) => {
      document.getElementById("OpenCBirthDayModal").click();
      // let embedUrl =
      //   "https://app.powerbi.com/rdlEmbed?reportId=" +
      //   this.configurationservice.configuration.RPReportId +
        "&rp:ExecTime=" +
        currentTime +
        "&rp:agencyid=" +
        this.global.globalAgencyId +
        "&rp:locationid=" +
        ((this.locationId != null && this.locationId != undefined && this.locationId != '') ? this.locationId : '00000000-0000-0000-0000-000000000000') +
        "&rp:userid=" +
        ((this.global.userID != null && this.global.userID != undefined && this.global.userID != '') ? this.global.userID : '00000000-0000-0000-0000-000000000000') +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      // let embedReportId = this.configurationservice.configuration.RPReportId;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        // embedUrl: embedUrl,
        // id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };
      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }
  generateLastDateReport() {
    let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.ViewReport = true;
    this.reptitle = "Last Date Of Service Report";
    this.CommonAPI.CommonFunctionforPowerBiToken().then((token) => {
      document.getElementById("OpenCBirthDayModal").click();
      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        this.environmentServicedata.LastDateOfServiceReportId +
        "&rp:ExecTime=" +
        currentTime +
        "&rp:agencyid=" +
        this.global.globalAgencyId +
        "&rp:locationid=" +
        ((this.locationId != null && this.locationId != undefined && this.locationId != '00000000-0000-0000-0000-000000000000') ? this.locationId : '') +
        "&rp:userid=" +
        ((this.global.userID != null && this.global.userID != undefined && this.global.userID != '00000000-0000-0000-0000-000000000000') ? this.global.userID : '') +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      let embedReportId = this.environmentServicedata.LastDateOfServiceReportId;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };
      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }
  inactiveClientrecord(){
    document.getElementById('openinactive').click();
    this.isClientReportInactive=true;
  }
  InactiveClientModal()
  {
    document.getElementById('openinactive').click();
    this.isClientReportInactive=false;
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
